// Patch ResizeObserver to wrap user callback and prevent "ResizeObserver loop completed"
// This runs early on app startup to reduce uncaught ResizeObserver loop errors in some browsers.
(function () {
    if (typeof window === 'undefined') return;
    const RO = window.ResizeObserver;
    if (!RO) return;

    try {
        // Create a wrapper constructor that safely invokes the original callback
        const Patched = function (callback) {
            const safeCb = function (entries, observer) {
                try {
                    return callback(entries, observer);
                } catch (err) {
                    // swallow errors from callbacks to avoid breaking the ResizeObserver loop
                    // Log in development for visibility
                    if (import.meta.env.DEV) console.error('ResizeObserver callback error:', err);
                }
            };
            return new RO(safeCb);
        };

        // Copy prototype so instanceof checks still work
        Patched.prototype = RO.prototype;
        // Preserve original toString
        Patched.toString = () => RO.toString();

        // Replace global ResizeObserver
        window.ResizeObserver = Patched;
    } catch (e) {
        // If patching fails, don't break startup
        if (import.meta.env.DEV) console.warn('Failed to patch ResizeObserver:', e);
    }
})();
